module.exports = __webpack_public_path__ + "img/0-58.d8cf7fb0.jpg";